import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import SftGlobalData from '../library/globalData';
import Menu from './Menu';
import logoDark from '../assets/logo_dark.png';
import './Sidebar.css';

function Sidebar({ isOpen, onToggle, language, isLoggedIn, searchValue, onSearch, singleDocMode = false }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [localSearch, setLocalSearch] = useState(searchValue || '');

    useEffect(() => {
        setLocalSearch(searchValue || '');
    }, [searchValue]);

    const handleLanguageChange = (newLang) => {
        const currentPath = window.location.pathname;
        const pathParts = currentPath.split('/').filter(Boolean);

        if (pathParts.length > 0 && SftGlobalData.languages.includes(pathParts[0])) {
            pathParts[0] = newLang;
        } else {
            pathParts.unshift(newLang);
        }

        navigate('/' + pathParts.join('/'));
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (localSearch.trim()) {
            onSearch(localSearch);
        }
    };

    const handleSearchChange = (e) => {
        setLocalSearch(e.target.value);
    };

    return (
        <>
            <button className="menu-toggle" onClick={onToggle}>
                {isOpen ? <CloseIcon /> : <MenuIcon />}
            </button>

            <aside className={`sidebar ${isOpen ? 'open' : 'closed'} slide-in-blurred-left`}>
                <div className="sidebar-header">
                    <img
                        src={logoDark}
                        alt="SoftTouch"
                        className="sidebar-logo logo-fade-in"
                        onClick={() => navigate(`/${language}/`)}
                    />
                </div>

                <div className="language-switcher">
                    {SftGlobalData.languages.map((lang) => (
                        <button
                            key={lang}
                            className={`lang-btn ${language === lang ? 'active' : ''}`}
                            onClick={() => handleLanguageChange(lang)}
                        >
                            {lang.toUpperCase()}
                        </button>
                    ))}
                </div>

                {isLoggedIn && !singleDocMode && (
                    <form className="search-form" onSubmit={handleSearchSubmit}>
                        <div className="search-input-wrapper">
                            <input
                                type="text"
                                className="search-input"
                                placeholder={t('searchPlaceholder')}
                                value={localSearch}
                                onChange={handleSearchChange}
                            />
                            <button type="submit" className="search-btn">
                                <SearchIcon />
                            </button>
                        </div>
                    </form>
                )}

                {isLoggedIn && !singleDocMode && (
                    <Menu language={language} />
                )}

            </aside>
        </>
    );
}

export default Sidebar;
